import { Middleware } from '@nuxt/types'
import { createNuxtMiddleware } from '@alao-frontend/utils'

const COOKIE_NAME = 'partner_referral'

const siteLevelReferralLink: Middleware = ctx => createNuxtMiddleware(
  ctx,
  (
    utils,
  ) => {
    const { route } = ctx

    if (!route.query.partner) {
      return
    }
    const {
      APP_DOMAIN: domain,
    } = ctx.$config

    const context = route.query.partner.toString()
    if (context.toLowerCase() === 'alao' || context.toLowerCase() === 'twint') {
      utils.setCookie(COOKIE_NAME, '', {
        domain,
        path: '/',
        expires: new Date(0),
      })
      return
    }

    utils.setCookie(COOKIE_NAME, context, {
      domain,
      path: '/',
    })
  })

export default siteLevelReferralLink
